import { buildCleanUrl, parseCleanUrl } from "./url.js";

var $ = jQuery;
var pending = null;
var debounceTimer = null;

function getWrapper() {
  return $("#ba-grid-wrapper");
}
function getGrid() {
  return $("#ba-grid");
}
function getPagination() {
  return $("#ba-grid-pagination");
}
function getCount() {
  return getWrapper().find(".ba-grid-count");
}
function getPerPage() {
  return getWrapper().data("per-page");
}
function getColClass() {
  return getWrapper().data("col-class");
}
function getBasePath() {
  return getWrapper().data("base-path");
}

/**
 * Initialize Select2 on state and city dropdowns.
 */
function initSelect2() {
  var opts = { allowClear: true, width: "100%" };
  $("#ba-filter-state").select2($.extend({}, opts, { placeholder: "All States" }));
  $("#ba-filter-city").select2($.extend({}, opts, { placeholder: "All Cities" }));
}

/**
 * Collect current filter values.
 */
function hasNewProfileFlag() {
  return new URLSearchParams(window.location.search).has("new_profile");
}

function getFilters(page) {
  return {
    action: "ba_grid_filter",
    _ajax_nonce: thryvSettings.baNonce,
    search: $("#ba-filter-search").val(),
    state: $("#ba-filter-state").val() || "",
    city: $("#ba-filter-city").val() || "",
    zip: $("#ba-filter-zip").val(),
    per_page: getPerPage(),
    col_class: getColClass(),
    paged: page || 1,
    new_profile: hasNewProfileFlag() ? "1" : "",
  };
}

/**
 * Fetch filtered results via AJAX and update the grid.
 */
function doFilter(page) {
  if (pending) pending.abort();
  getGrid().css("opacity", "0.4");

  var filters = getFilters(page);

  // Update browser URL.
  var cleanUrl = buildCleanUrl(getBasePath(), {
    state: filters.state,
    city: filters.city,
    search: filters.search,
    zip: filters.zip,
    page: filters.paged,
  });
  window.history.replaceState(null, "", cleanUrl);

  pending = $.post(thryvSettings.ajaxurl, filters, function (data) {
    pending = null;
    getGrid().html(data.html).css("opacity", "1");
    getPagination().html(data.pagination);
    getCount().text(data.total);
  });
}

/**
 * Debounced version of doFilter for text inputs.
 */
function debouncedFilter() {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(function () {
    doFilter(1);
  }, 300);
}

/**
 * Update the other dropdown's options when one changes.
 * State change → reload city options. City change → reload state options.
 */
function updateDropdowns(changedField) {
  var state = $("#ba-filter-state").val() || "";
  var city = $("#ba-filter-city").val() || "";

  $.post(
    thryvSettings.ajaxurl,
    {
      action: "ba_get_terms",
      _ajax_nonce: thryvSettings.baNonce,
      state: state,
      city: city,
      changed: changedField,
    },
    function (data) {
      if (changedField === "state" && data.cities) {
        rebuildSelect("#ba-filter-city", data.cities, "All Cities");
      }
      if (changedField === "city" && data.states) {
        rebuildSelect("#ba-filter-state", data.states, "All States");
      }
    },
  );
}

/**
 * Rebuild a <select> element with new options, preserving current value if possible.
 */
function rebuildSelect(selector, terms, placeholder) {
  var $el = $(selector);
  var current = $el.val();

  $el.empty().append('<option value="">' + placeholder + "</option>");
  $.each(terms, function (i, term) {
    $el.append('<option value="' + term.slug + '">' + term.name + "</option>");
  });

  if (current && $el.find('option[value="' + current + '"]').length) {
    $el.val(current);
  }
  $el.trigger("change.select2");
}

/**
 * Bind state/city change handler (extracted so we can re-bind after reset).
 */
function bindStateChange() {
  $("#ba-filter-state").on("change select2:clear", function () {
    updateDropdowns("state");
    doFilter(1);
  });
}

function bindCityChange() {
  $("#ba-filter-city").on("change select2:clear", function () {
    updateDropdowns("city");
    doFilter(1);
  });
}

/**
 * Bind all filter event listeners.
 */
function bindFilterEvents() {
  bindStateChange();
  bindCityChange();

  // Text inputs (debounced).
  $("#ba-filter-search, #ba-filter-zip").on("input", debouncedFilter);

  // Location toggle (show more / show less).
  $(document).on("click", ".ba-card-location-toggle", function (e) {
    e.preventDefault();
    var $text = $(this).siblings(".ba-card-location-text");
    var expanded = $text.hasClass("expanded");
    $text.toggleClass("expanded");
    $(this).text(expanded ? "Show more" : "Show less");
  });

  // Pagination.
  $(document).on("click", "#ba-grid-pagination a.page-link", function (e) {
    e.preventDefault();
    var page = $(this).data("page");
    if (page) {
      doFilter(page);
      $("html, body").animate({ scrollTop: getWrapper().offset().top - 120 }, 300);
    }
  });

  // Reset.
  $("#ba-filter-reset").on("click", function () {
    $("#ba-filter-search").val("");
    $("#ba-filter-zip").val("");

    // Unbind to prevent triggering updateDropdowns during reset.
    $("#ba-filter-state").off("change select2:clear").val("").trigger("change.select2");
    $("#ba-filter-city").off("change select2:clear").val("").trigger("change.select2");

    // Restore full option lists.
    updateDropdowns("state");
    updateDropdowns("city");

    // Re-bind after a tick.
    setTimeout(function () {
      bindStateChange();
      bindCityChange();
    }, 100);

    doFilter(1);
  });

  // Browser back/forward.
  window.addEventListener("popstate", function () {
    var p = parseCleanUrl(getBasePath());
    $("#ba-filter-state").val(p.state).trigger("change.select2");
    $("#ba-filter-city").val(p.city).trigger("change.select2");
    $("#ba-filter-search").val(p.search);
    $("#ba-filter-zip").val(p.zip);
    doFilter(p.page);
  });
}

/**
 * Restore filter state from the current URL on page load.
 * Only triggers a filter if URL has params (initial HTML is already server-rendered).
 */
function restoreFromUrl() {
  // No-op: the PHP already renders the correct initial state from query vars.
  // The popstate handler covers browser navigation.
}

export { initSelect2, bindFilterEvents, restoreFromUrl };
